import { createSlice } from "@reduxjs/toolkit";
import {
  getAllNotifications,
  sendNotification,
  updateNotification,
} from "store/actions/notificationSlice";

const initialState = {
  isLoading: false,
  loading: false,
  perPage: 12,
  totalCount: null,
  totalPages: null,
  currentPage: null,
  notifications: [],
};

const notification = createSlice({
  name: "notification",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getAllNotifications.pending, (state) => {
        state.loading = true;
      })
      .addCase(getAllNotifications.fulfilled, (state, action) => {
        state.loading = false;
        const { success } = action.payload || {};
        if (success) {
          const { data, totalCount, totalPages, currentPage } =
            action.payload || {};
          state.notifications = data;

          state.totalCount = totalCount || null;
          state.totalPages = totalPages || null;
          state.currentPage = currentPage || null;
        }
      })
      .addCase(getAllNotifications.rejected, (state, action) => {
        state.loading = false;
      });

    builder
      .addCase(sendNotification.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(sendNotification.fulfilled, (state, action) => {
        state.isLoading = false;
      })
      .addCase(sendNotification.rejected, (state, action) => {
        state.isLoading = false;
      });

    builder
      .addCase(updateNotification.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(updateNotification.fulfilled, (state, action) => {
        state.isLoading = false;
      })
      .addCase(updateNotification.rejected, (state, action) => {
        state.isLoading = false;
      });
  },
});

export default notification.reducer;
